import { waitForElementToExist } from './waitForElement';

/* eslint-disable */
export const loginPage = () => {
	const titleStyle = ({ headboard }) => {
		headboard.classList = `font-bold uppercase headlines-font text-4xl xl:text-5xl text-center headline-title gap-4 text-brown mb-8 mt-12">Checkout`
	}
	const bgPage = ({ main }) => {
		if (main.querySelector('.bg-image')) return;
		const bgImage = document.createElement('img')
		/* image background */
		bgImage.src = template.texture_default;
		bgImage.classList = 'bg-image absolute inset-0 object-cover object-top w-full h-full mix-blend-multiply opacity-20 z-[1]'
		main.appendChild(bgImage)
	}
	const stylesPage = ({ page }) => {
		/* title */
		const headboard = page.querySelector('.c7-h1');
		headboard && (titleStyle({ headboard }));

		const main = page.closest('#primary');
		main && (main.style = 'min-height: auto;');
		main && (main.classList = 'py-12 lg:py-24');
		main && (bgPage({ main }));

		const optionCreate = page.querySelector('.c7-account-login__options');
		optionCreate && (optionCreate.classList += ' pt-4 border-t-2 border-brown/20 font-medium')
		const optionLink = optionCreate && optionCreate.querySelector('.c7-link');
		if (optionLink) {
			optionLink.querySelector('svg') && optionLink.querySelector('svg').remove();
			const optionTextContent = optionLink.textContent;
			const isCreate = optionTextContent === 'Create one' || optionTextContent === 'Create your account';
			optionLink.textContent = (isCreate ? 'Create your account' : 'Sign in');
			isCreate ?
				optionLink.insertAdjacentHTML('beforeend', `<svg style="stroke: none; stroke-width: 0;" xmlns="http://www.w3.org/2000/svg" width="18.888" height="18.889" viewBox="0 0 18.888 18.889"><g id="edit" transform="translate(0.9 0.9)"><g id="Group_25573" data-name="Group 25573">
			<path id="Union_10" data-name="Union 10" d="M3541.459-5162.515a2.612,2.612,0,0,1-2.608-2.61v-11.96a2.612,2.612,0,0,1,2.608-2.609h3.417a.9.9,0,0,1,.9.9.9.9,0,0,1-.9.9h-3.417a.81.81,0,0,0-.809.809v11.96a.81.81,0,0,0,.809.809h11.962a.81.81,0,0,0,.808-.809v-3.417a.9.9,0,0,1,.9-.9.9.9,0,0,1,.9.9v3.417a2.612,2.612,0,0,1-2.608,2.61Zm3.417-5.127a.9.9,0,0,1-.644-.271.9.9,0,0,1-.253-.689l.256-3.845a.894.894,0,0,1,.261-.576l8.117-8.117a.9.9,0,0,1,.636-.264.9.9,0,0,1,.637.264l3.588,3.589a.9.9,0,0,1,0,1.269l-8.117,8.2a.9.9,0,0,1-.6.267l-3.845.171Zm1.133-4.347-.168,2.5,2.489-.11,7.239-7.316-2.32-2.319Z" transform="translate(-3539.75 5180.504)" fill="#7b5d27"/>
			</g></g></svg>`)
				: optionLink.insertAdjacentHTML('beforeend', `<svg style="stroke: none; stroke-width: 0;" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
			<path id="log-in" d="M13.7,3.8h3.6a.9.9,0,0,1,.9.9V17.3a.9.9,0,0,1-.9.9H13.7a.9.9,0,1,0,0,1.8h3.6A2.7,2.7,0,0,0,20,17.3V4.7A2.7,2.7,0,0,0,17.3,2H13.7a.9.9,0,1,0,0,1.8Zm-2.173,6.3H2.9a.9.9,0,0,0,0,1.8h8.627L8.564,14.864a.9.9,0,0,0,1.273,1.273l4.5-4.5a.9.9,0,0,0,0-1.273l-4.5-4.5A.9.9,0,0,0,8.564,7.136Z" transform="translate(-2 -2)" fill="#7b5d27"/>
			</svg>`)
			optionLink.classList += ' text-brown uppercase font-semibold inline-flex items-center gap-2 pl-2';
		}

		const passwordReset = page.querySelector('.c7-account-login__password-options a');
		passwordReset && (passwordReset.textContent = 'Forgot password');
	}
	waitForElementToExist({ selector: '#c7-content .c7-account-login' }).then(() => {
		const loginElement = document.querySelector('#c7-content');
		if (!loginElement) return;
		stylesPage({ page: loginElement })

		const observer = new MutationObserver((mutationsList, observer) => {
			for (const mutation of mutationsList) {
				if (mutation.type === 'childList') {
					const loginElement = document.querySelector('#c7-content');
					if (!loginElement) return;
					stylesPage({ page: loginElement })
				}
			}
		});
		observer.observe(document.querySelector('#c7-content'), { childList: true });
		
		waitForElementToExist({ selector: '#c7-content .c7-account .c7-account__header' }).then(() => {
			const pageElement = document.querySelector('#c7-content');
			pageElement.style = 'opacity: 0;';
			// reload window page	
			window.location.reload();
		})
	});
}